module.exports = __webpack_public_path__ + "img/collection-weddingRingsMulticolor@2x.79fc4d6.jpg";